import { searchJobs, tagCandidatesToJob } from '../../../../services/popupApi';

export const api = {
  searchOptions: async (field, search) => {
    if (field.searchFetchKey === 'tagToJobJobList') return searchJobs(search);
    return [];
  },
  submit: async (values, context) => {
    await tagCandidatesToJob({
      jobId: values.jobId ?? context.jobId,
      candidateIds: context.selectedIds,
      hiringStage: values.hiringStage ?? context.hiringStage,
    });
  },
};
